module.exports = __webpack_public_path__ + "44f3e6d691a8fc186d19747f31e3d70a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icons/turn-arrow.svg
// module id = 135
// module chunks = 0